type BucketLike = {
  id?: number | null;
  bucket_name?: string;
  isSyntheticOther?: boolean;
};

type AttachmentLike = {
  attachment_id?: number | null;
  bucket_name?: string;
};

export const isSyntheticOtherBucket = (bucket?: BucketLike | null) => Boolean(bucket?.isSyntheticOther);

export const podBucketAssociatePayload = (fileId: number, bucket: BucketLike) =>
  isSyntheticOtherBucket(bucket) ? { file_id: fileId } : { file_id: fileId, attachment_id: bucket.id };

export const attachmentMatchesBucket = (item: AttachmentLike, bucket: BucketLike) => {
  if (isSyntheticOtherBucket(bucket)) {
    return item.attachment_id == null || item.bucket_name === bucket.bucket_name;
  }
  return item.attachment_id === bucket.id;
};

// Confirm checkboxes use UI bucket.id (synthetic Other is 1). Keep file attachment_id as the API id.
export const selectedAttachmentsByBucketId = (
  buckets: BucketLike[],
  attachments: AttachmentLike[],
): Record<string, boolean> => {
  const nextSelected: Record<string, boolean> = {};
  buckets.forEach((bucket) => {
    if (bucket.id == null) {
      return;
    }
    nextSelected[`bucket-${bucket.id}`] = attachments.some((item) => attachmentMatchesBucket(item, bucket));
  });
  return nextSelected;
};

export const isOngoingPodAttachmentReadOnly = (...statuses: Array<string | null | undefined>) =>
  statuses.some((status) => {
    const normalized = status?.toLowerCase() ?? "";
    return normalized === "delivered" || normalized === "auto-closed";
  });

export const markShipmentQueryDelivered = (prev: any) => {
  if (!prev) {
    return prev;
  }
  return {
    ...prev,
    organization: {
      ...prev.organization,
      shipment_status: "Delivered",
    },
    shipment: prev.shipment
      ? {
          ...prev.shipment,
          shipment_status: "Delivered",
        }
      : prev.shipment,
  };
};
